import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import { HomeView } from "components/views/HomeView";
export default function Home() {
  return <HomeView />
}

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...await serverSideTranslations(locale, [
        "host",
        "common",
      ])
    }
  }
};
